import { render, staticRenderFns } from "./sayiinput.vue?vue&type=template&id=5550c0b3&scoped=true&"
import script from "./sayiinput.vue?vue&type=script&lang=js&"
export * from "./sayiinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5550c0b3",
  null
  
)

export default component.exports